@if (view$ | async; as view) {
    <div class="d-flex justify-content-between m-3">
        <h5 class="text-start w-100">
            {{ 'event-alarms_create-event-alarm-help-text' | translate }}
        </h5>
    </div>
    <div class="container-fluid mt-3">
        <form
            [formGroup]="view.formGroup"
            (submit)="submit(view.buildingNo, view.eventTypeId)"
            class="mt-3 mb-3 mx-auto slim-card-container">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body">
                        <app-input-text-group
                            formControlName="alarmName"
                            [label]="'monitoring_alarm-name' | translate" />
                    </div>
                </div>
            </div>

            <app-select-vendor-models
                [vendorModels]="view.vendorModels"
                (vendorModelsChange)="onVendorModelsChange($event)" />

            <app-control-messages
                [control]="view.formGroup.controls.vendorModels"
                class="d-block position-relative w-100" />

            @if (view.allEventTypesUnsupported) {
                @if (subscriptionId$ | async; as id) {
                    <div class="alert alert-warning my-3" role="alert">
                        {{
                            'event-alarms_No_supported_vendorModels_prompt_delete_alarm' | translate
                        }}
                        <button
                            type="button"
                            class="btn btn-link p-0"
                            (click)="
                                deleteEventAlarm(
                                    view.buildingNo,
                                    view.formGroup.getRawValue().alarmName,
                                    id
                                )
                            ">
                            {{ 'common_click-here-to-delete' | translate }}
                        </button>
                    </div>
                }
            }
            <div class="col-6 mt-3">
                <div class="card">
                    <div class="card-body">
                        <app-input-number-group
                            formControlName="throttleInHours"
                            [label]="
                                'variable-alarms_notify-me-instantly-and-thereafter-only-every'
                                    | translate
                            "
                            [information]="'event-alarms_notification-description' | translate"
                            [descriptor]="
                                'titles_frequency-hours' | translate: 'online' : 'monitoringAlarms'
                            "></app-input-number-group>

                        <app-input-email-list
                            [label]="'monitoring_e-mails' | translate"
                            formControlName="recipients" />
                    </div>
                </div>
            </div>

            <div class="text-end mt-3">
                <button
                    type="button"
                    class="btn btn-outline-primary"
                    (click)="back(view.buildingNo)">
                    {{ 'actions_back' | translate: 'online' : 'common' }}
                </button>
                <button
                    class="btn btn-outline-primary ms-1"
                    type="button"
                    (click)="resetForm(view.formGroup)">
                    {{ 'utilities_reset' | translate }}
                </button>

                <button class="btn btn-primary ms-1" type="submit">
                    {{ 'actions_save' | translate: 'online' : 'common' }}
                </button>
            </div>
        </form>
    </div>
} @else {
    <app-load />
}
